// extracted by mini-css-extract-plugin
export default {"grid":"CallStatusSummary_grid__ZzY6L","detailRow":"CallStatusSummary_detailRow__x2CES","deepDivePlaceholder":"CallStatusSummary_deepDivePlaceholder__CukPQ"};